"use client"

import { useState } from "react"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import { NpInput } from "src/components/np-design/components/input/NpInput"
import { NpErrorMessage } from "src/components/np-design/components/NpErrorMessage"
import { NpEmailPrivacy } from "src/components/np-design/sections/newsletter/NpEmailPrivacy"
import { NpEmailSignupFeedback } from "src/components/np-design/sections/newsletter/NpEmailSignupFeedback"
import { handleEmailChange, useKlaviyoFormSubmit } from "src/components/np-design/sections/newsletter/state"
import { genericErrorMessage } from "src/utilities/errorMessages"

export type NpEmailSignupFormProps = {
  listId: string
  name: string
}

export const NpEmailSignupForm = ({ listId, name }: NpEmailSignupFormProps) => {
  const [firstOptIn, setFirstOptIn] = useState(false)
  const [secondOptIn, setSecondOptIn] = useState(false)

  const { email, loading, error, handleSubmit } = useKlaviyoFormSubmit(listId, name, (hasConsent) => {
    setFirstOptIn(true)
    setSecondOptIn(hasConsent)
  })

  if (secondOptIn) {
    return (
      <NpEmailSignupFeedback heading="Geschafft!" message="Du hast bist angemeldet und kannst nichts mehr verpassen!" />
    )
  }
  if (firstOptIn) {
    return (
      <NpEmailSignupFeedback
        heading="Fast geschafft!"
        message="Bestätige deine Anmeldung in der Email, die wir dir gesendet haben. Schau dafür in deinem Email-Postfach nach."
      />
    )
  }

  return (
    <form
      onSubmit={handleSubmit}
      inert={loading}
      className="mx-auto flex w-100 max-w-full grid-cols-1 flex-col items-stretch gap-4 whitespace-nowrap xl:gap-6"
    >
      <NpInput
        type="email"
        autoComplete="home email"
        placeholder="E-Mail"
        required
        value={email?.value}
        onChange={handleEmailChange}
      />

      <NpButton type="submit" size="md" loading={loading}>
        Jetzt anmelden
      </NpButton>

      {error && (
        <div className="text-base">
          <NpErrorMessage message={genericErrorMessage} />
        </div>
      )}

      <NpEmailPrivacy />
    </form>
  )
}
